<div class="container-login100 animated fadeIn">
  <div class="wrap-login100 box-shadow">
    <div class="login100-form-title">
      <div class="text-center">
        <img src="../../../assets/imgs/logo-um.png" class="responsive-logo" />
      </div>
    </div>

    <div class="section-form-login">
      <div *ngIf="exibirLoadingLogin">
        <div class="spinner"></div>
        <p class="text-center" style="color: #777; margin: -70px 0 100px">
          Carregando, por favor aguarde ...
        </p>
      </div>

      <div class="login-logo-empresa pull-left"
        [ngClass]="{ 'animated fadeInLeft': openLogin, 'hide-div': !openLogin }">
        <img [src]="logo" class="responsive-logo" style="border-radius: 5px; width: 190px" />

        <div class="institutional-info">
          <h4>Institucional</h4>

          <p>
            <span>
              <i class="fas fa-envelope"></i>
              <strong>E-mail:</strong>
            </span>
            <a href="mailto:cge@cge.pi.gov.br">cge@cge.pi.gov.br</a>
          </p>
          <p>
            <span>
              <i class="fas fa-phone"></i>
              <strong>Telefone:</strong>
            </span>
            <a href="tel:+558633262000">(86) 3326-2000</a>
          </p>
          <p>
            <span>
              <i class="fab fa-whatsapp"></i>
              <strong>WhatsApp:</strong>
            </span>
            <a style="color: #0073b7" href="https://wa.me/5586994261735">(86) 99426-1735</a>
          </p>
          <p>
            <span>
              <i class="fas fa-globe"></i>
              <strong>Portal:</strong>
            </span>
            <a href="https://portal.pi.gov.br/cge/">portal.pi.gov.br/cge</a>
          </p>
          <p>
            <span>
              <i class="fas fa-clock"></i>
              <strong>Funcionamento:</strong>
            </span>
            <a>segunda a sexta-feira, das 7:30h às 13:30h</a>
          </p>
        </div>
      </div>

      <div class="login-form-sessao pull-right" [ngClass]="{
          'animated fadeInRight': openLogin,
          'hide-div': !openLogin
        }">
        <h3>Iniciar sessão</h3>
        <br />
        <br />
        <div class="wrap-input100" style="margin-bottom: 25px">
          <span class="label-input100">E-mail</span>
          <input class="input100" type="text" name="usuario" placeholder="Digite seu e-mail" ngModel required
            #usuario (keyup.enter)="senha.focus()" />
          <span class="focus-input100"></span>
        </div>

        <div class="wrap-input100" style="margin-bottom: 20px">
          <span class="label-input100">Senha</span>
          <input class="input100" type="password" name="senha" placeholder="Digite sua senha" ngModel required #senha
            (keyup.enter)="onLoginEnter(usuario, senha)" />
          <i class="fas fa-eye-slash"
            style="cursor: pointer; position: absolute; right: 10px; top: 50%; transform: translateY(-50%);"
            *ngIf="senha.type === 'password'" (click)="senha.type = 'text'"></i>
          <i class="fas fa-eye"
            style="cursor: pointer; position: absolute; right: 10px; top: 50%; transform: translateY(-50%);"
            *ngIf="senha.type === 'text'" (click)="senha.type = 'password'"></i>
          <span class="focus-input100"></span>
        </div>

        <div class="container-login100-form-btn">
          <button [disabled]="!usuario.value || !senha.value"
            class="login100-form-btn" (click)="exibirDialogoVerificacao(usuario.value, senha.value); senha.value = ''">
            <i class="fas fa-sign-in-alt"></i>
            Login
          </button>
          <a (click)="openForgotPassVIew()" class="txt2 col-sm-6 cursor">
            Esqueceu sua senha?
          </a>
        </div>

        <br>
        <hr class="col-sm-12 no-padding" />
        <br>
        <div class="col-sm-12 no-padding menu-buttons">
          <button class="btn-app btn-app-login" pTooltip="Cadastrar nova Organização da Sociedade Civil (OSC)" tooltipPosition="top"
           [routerLink]="['/outras-opcoes/nova-entidade']">
            <i class="fas fa-building"></i>
            <span>Cadastrar OSC</span>
          </button>
          <button class="btn-app btn-app-login" pTooltip="Realizar nova inscrição em eventos" tooltipPosition="top"
           [routerLink]="['/matricula']">
            <i class="fas fa-graduation-cap"></i>
            <span>Eventos</span>
          </button>
          <button class="btn-app btn-app-login" pTooltip="Acessar tutoriais do sistema SIGRP" tooltipPosition="top"
           [routerLink]="['/tutoriais-publicos']">
            <i class="fas fa-play-circle"></i>
            <span>Tutoriais</span>
          </button>
          <button class="btn-app btn-app-login" pTooltip="Acessar outras opções" tooltipPosition="top"
           [routerLink]="['/outras-opcoes']">
            <i class="fas fa-ellipsis-h"></i>
            <span>Outras opções</span>
          </button>
        </div>
      </div>

      <div class="login-form" [ngClass]="{
          'animated fadeInRight': openForgotPass,
          'hide-div': !openForgotPass
        }" *ngIf="!loading">
        <h3>Recuperação de senha</h3>
        <br />
        <br />
        <div class="wrap-input100" style="margin-bottom: 30px">
          <span class="label-input100">E-mail</span>
          <input class="input100" type="text" name="email" placeholder="Digite seu e-mail" required
            [(ngModel)]="esqueciSenha.email" />
          <span class="focus-input100"></span>
        </div>

        <div class="container-login100-form-btn">
          <button class="login100-form-btn" (click)="novaSolicitacao()">
            Recuperar senha
          </button>
          <a class="txt2 col-sm-6 cursor" (click)="openLoginView()">
            Voltar Login
          </a>
        </div>
      </div>

      <div class="login-form" [ngClass]="{
          'animated fadeInRight': openToken,
          'hide-div': !openToken
        }">
        <h3>Confirmação de código</h3>
        <p>Um código foi enviado para o email digitado.</p>
        <br />
        <br />
        <div class="wrap-input100" style="margin-bottom: 30px">
          <span class="label-input100">Código</span>
          <input class="input100" type="text" name="token" placeholder="Digite o código recebido" required
            [(ngModel)]="esqueciSenha.token" />
          <span class="focus-input100"></span>
        </div>

        <div class="container-login100-form-btn">
          <button class="login100-form-btn" (click)="openNewPassView()">
            Continuar
          </button>
          <a class="txt2 col-sm-6 pull-right text-center cursor" (click)="openLoginView()">
            Voltar Login
          </a>
        </div>
      </div>

      <div class="login-form" [ngClass]="{
          'animated fadeInRight': openNewPass,
          'hide-div': !openNewPass
        }">
        <h3>Criar nova senha</h3>
        <br />
        <br />
        <div class="wrap-input100" style="margin-bottom: 30px">
          <span class="label-input100">Senha</span>
          <input class="input100" type="password" name="senha" placeholder="Digite a nova senha" required
            [(ngModel)]="esqueciSenha.senha" #novaSenha />
          <i class="fas fa-eye-slash"
            style="cursor: pointer; position: absolute; right: 10px; top: 50%; transform: translateY(-50%);"
            *ngIf="novaSenha.type === 'password'" (click)="novaSenha.type = 'text'"></i>
          <i class="fas fa-eye"
            style="cursor: pointer; position: absolute; right: 10px; top: 50%; transform: translateY(-50%);"
            *ngIf="novaSenha.type === 'text'" (click)="novaSenha.type = 'password'"></i>
          <span class="focus-input100"></span>
        </div>
        <div class="wrap-input100" style="margin-bottom: 30px">
          <span class="label-input100">Confirmação</span>
          <input class="input100" type="password" name="confirmeSenha" placeholder="Digite a confirmação da senha"
            required [(ngModel)]="confirmeSenha" #confirmaSenha />
          <i class="fas fa-eye-slash"
            style="cursor: pointer; position: absolute; right: 10px; top: 50%; transform: translateY(-50%);"
            *ngIf="confirmaSenha.type === 'password'" (click)="confirmaSenha.type = 'text'"></i>
          <i class="fas fa-eye"
            style="cursor: pointer; position: absolute; right: 10px; top: 50%; transform: translateY(-50%);"
            *ngIf="confirmaSenha.type === 'text'" (click)="confirmaSenha.type = 'password'"></i>
          <span class="focus-input100"></span>
        </div>

        <div class="container-login100-form-btn">
          <button class="login100-form-btn" (click)="confirmarAlteracao()">
            Salvar
          </button>
          <a class="txt2 col-sm-6 pull-right text-center cursor" (click)="openLoginView()">
            Voltar Login
          </a>
        </div>
      </div>
    </div>

    <div class="col-sm-12 text-center footer">by nflsoftware.com</div>
  </div>
</div>

<p-dialog [style]="{width: '440px'}" [(visible)]="displayEscolhaTokenDialog" [modal]="true" [closable]="false"
  [showHeader]="false" styleClass="verification-dialog">
  <div class="verification-dialog-content">
    <button type="button" class="verification-close-btn" (click)="fecharDialogoVerificacao()" aria-label="Fechar">
      <i class="fas fa-times"></i>
    </button>

    <div class="verification-icon">
      <i class="fas fa-shield-alt"></i>
    </div>

    <h3 class="verification-title">Código de Verificação</h3>
    <p class="verification-subtitle">
      Já existe um código gerado em <strong>{{ dataUltimoToken }}</strong>. Deseja utilizar esse código ou gerar um
      novo?
    </p>

    <div class="verification-actions">
      <button type="button" class="verification-btn verification-btn-ghost" (click)="usarUltimoCodigo()">
        Usar último código
      </button>
      <button type="button" class="verification-btn verification-btn-primary" (click)="gerarNovoCodigo()">
        Gerar novo código
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog [style]="{width: '440px'}" [(visible)]="displayVerificationDialog" [modal]="true" [closable]="false"
  [showHeader]="false" styleClass="verification-dialog">
  <div class="verification-dialog-content">
    <button type="button" class="verification-close-btn" (click)="fecharDialogoVerificacao()" aria-label="Fechar">
      <i class="fas fa-times"></i>
    </button>

    <div class="verification-icon">
      <i class="fas fa-shield-alt"></i>
    </div>

    <h3 class="verification-title">Verificação de Segurança</h3>
    <p class="verification-subtitle" *ngIf="!usandoUltimoCodigo">
      Enviamos um código de verificação para o e-mail <strong>{{ usuario.value }}</strong>. Caso não tenha recebido,
      verifique sua caixa de spam ou lixo eletrônico.
    </p>
    <p class="verification-subtitle" *ngIf="usandoUltimoCodigo">
      Utilize o código gerado em <strong>{{ dataUltimoToken }}</strong> e enviado para o e-mail
      <strong>{{ usuario.value }}</strong>.
    </p>

    <div class="verification-code-field">
      <input type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="000000"
        class="verification-code-input" [class.is-invalid]="codigoInvalido" [(ngModel)]="codigoVerificacao"
        (keyup.enter)="verificarCodigo()" />
    </div>
    <small class="verification-error-msg" *ngIf="codigoInvalido">
      <i class="fas fa-exclamation-circle"></i> Código inválido. Tente novamente.
    </small>

    <button type="button" class="verification-resend-btn" (click)="reenviarCodigo()"
      [disabled]="timerAtivo || tempoRestante > 0">
      <i class="fas fa-sync-alt" *ngIf="!timerAtivo && tempoRestante === 0"></i>
      <i class="fas fa-clock" *ngIf="timerAtivo || tempoRestante > 0"></i>
      {{ (timerAtivo || tempoRestante > 0) ? 'Reenviar código em ' + tempoRestante + 's' : 'Reenviar código' }}
    </button>

    <div class="verification-actions">
      <button type="button" class="verification-btn verification-btn-ghost" (click)="fecharDialogoVerificacao()">
        Cancelar
      </button>
      <button type="button" class="verification-btn verification-btn-primary" (click)="verificarCodigo()">
        Verificar
      </button>
    </div>
  </div>
</p-dialog>